import api from "@/api";
import { JSConn } from "@/utilities/js-conn";

interface CalendarUrl {
  url: string;
  token: string;
  token_id: string;
}

interface CalendarUrlState {
  calendarUrls: CalendarUrl[];
  calendarUrl: CalendarUrl | {};
}

const itemDetails = {
  pluralName: "calendar_urls",
  singularName: "calendar_url",
};

const apiParamsBuilder = (jsConn: JSConn) => {
  return {
    id: jsConn.formParams.id,
    calendar_url: {
      ...jsConn.formParams,
    },
  };
};

const state: CalendarUrlState = {
  calendarUrls: [],
  calendarUrl: {},
};

const mutations = {
  LOAD_CALENDAR_URLS(state: CalendarUrlState, payload: CalendarUrl[]) {
    state.calendarUrls = payload;
  },
  LOAD_CALENDAR_URL(state: CalendarUrlState, payload: CalendarUrl) {
    state.calendarUrl = payload;
  },
};

const actions = {
  createCalendarUrl(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api
      .createItem(jsConn, itemDetails)
      .then(jsConn => {
        context.commit("LOAD_CALENDAR_URL", jsConn.response);
        return Promise.resolve(jsConn);
      })
      .catch(jsConn => {
        return Promise.reject(jsConn);
      });
  },
};

const getters = {
  calendarUrls: (state: CalendarUrlState) => {
    return state.calendarUrls;
  },
  calendarUrl: (state: CalendarUrlState) => {
    return state.calendarUrl;
  },
};

const calendarUrlsModule = {
  state,
  mutations,
  actions,
  getters,
};

export default calendarUrlsModule;
